import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import BackstageGrid from '../../BackstageGrid';

import ArtistFeaturedContentGridItem from './ArtistFeaturedContentGridItem';

const ArtistFeaturedContent = props => {
  const { featuredContentIds } = props;
  if (featuredContentIds.size <= 0) return null;
  return (
    <D.ContentSection
      isGridList={true}
      title={<FormattedMessage {...BackstageConstants.messages.spotlight} />}
    >
      <BackstageGrid>
        {featuredContentIds.map(pandoraId => (
          <ArtistFeaturedContentGridItem pandoraId={pandoraId} key={pandoraId} />
        ))}
      </BackstageGrid>
    </D.ContentSection>
  );
};

ArtistFeaturedContent.propTypes = {
  featuredContentIds: ImmutablePropTypes.listOf(PropTypes.string),
};

export default ArtistFeaturedContent;
